import { createReducerContext } from '../../../../utils/create-reducer-context';
import { AgreementSearchState, AgreementSearchReducer, ACTION_TYPES } from './agreement-search-reducer';

const initialState: AgreementSearchState = {
    parameters: { page: 0, pageSize: 25 },
    searchTrigger: 0,
    drawer: { open: false },
};

const { Provider: AgreementSearchProvider, useStateContext: useAgreementSearchState, useDispatchContext: useAgreementSearchDispatch } = createReducerContext('AgreementSearch', AgreementSearchReducer, initialState);

export { AgreementSearchProvider, useAgreementSearchState, useAgreementSearchDispatch, ACTION_TYPES };
